<template>
  <!-- 申请代开发票退款/详情 -->
  <dialogModel
    :title="dialogTitle"
    width="1200px"
    :visible.sync="VisibleDeRe"
    @handleClose="handleClose"
    @handleOk="handleUnderstand"
    :footer="DeRe == 1"
  >
    <span
      slot="titleRight"
      class="detail-status"
      :class="$tool.getProxyStatusClass(row)"
      :style="{ color: $tool.getProxyStatusColor(row) }"
    >
      {{ row.invalid == 2 ? "作废" : row.statusName || "--" }}
    </span>
    <div class="dialog-content">
      <div class="Content">
        <div class="section-row">
          <div class="section-col">
            <div class="title">销售方信息</div>
            <div class="Content-box">
              <div class="title-p">销售方</div>
              <div class="title-con">{{ row.sellerName }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">统一社会信用代码</div>
              <div class="title-con">{{ row.sellerCreditCode }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">法定代表人(负责人)</div>
              <div class="title-con">{{ row.sellerLegalPerson }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">企业类型</div>
              <div class="title-con">
                {{
                  row.sellerCompanyType == 0
                    ? "有限公司"
                    : row.sellerCompanyType == 1
                    ? "个体户"
                    : row.sellerCompanyType == 2
                    ? "子公司"
                    : row.sellerCompanyType == 3
                    ? "分公司"
                    : row.sellerCompanyType == 4
                    ? "其他"
                    : "--"
                }}
              </div>
            </div>
            <div class="Content-box">
              <div class="title-p">纳税类型</div>
              <div class="title-con">
                {{ row.sellerTaxType == 0 ? "小规模纳税人" : "一般纳税人" }}
              </div>
            </div>
            <div class="Content-box">
              <div class="title-p">开户银行名称</div>
              <div class="title-con">{{ row.sellerBankName || "--" }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">基本开户账号</div>
              <div class="title-con">{{ row.sellerBankAccount || "--" }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">住所</div>
              <div class="title-con">{{ row.sellerCompanyAddress }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">联系电话</div>
              <div class="title-con">{{ row.sellerPhone }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">是否展示</div>
              <div class="title-con">
                {{ row.showSellerInfo == 1 ? "展示" : "隐藏" }}
              </div>
            </div>
            <div class="Instruction">
              (用于发票展示信息，包括开户银行、开户账号、住所)
            </div>
          </div>

          <div class="section-col">
            <div class="title">购买方信息</div>
            <div class="Content-box">
              <div class="title-p">购买方</div>
              <div class="title-con">{{ row.customerName }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">
                {{
                  row.headTypeName == "个人" ? "身份证号码" : "统一社会信用代码"
                }}
              </div>
              <div class="title-con">{{ row.customerCreditCode }}</div>
            </div>
            <div class="Content-box" v-if="row.headTypeName != '个人'">
              <div class="title-p">企业类型</div>
              <div class="title-con">
                {{
                  row.customerCompanyType == 0
                    ? "有限公司"
                    : row.customerCompanyType == 1
                    ? "个体户"
                    : row.customerCompanyType == 2
                    ? "子公司"
                    : row.customerCompanyType == 3
                    ? "分公司"
                    : row.customerCompanyType == 4
                    ? "其他"
                    : "--"
                }}
              </div>
            </div>
            <div class="Content-box">
              <div class="title-p">联系电话</div>
              <div class="title-con">{{ row.customerPhone }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">开户银行名称</div>
              <div class="title-con">{{ row.customerBankName || "--" }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">基本开户账号</div>
              <div class="title-con">{{ row.customerBankAccount || "--" }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">住所</div>
              <div class="title-con">
                {{ row.customerCompanyAddress || "--" }}
              </div>
            </div>
            <div class="Content-box">
              <div class="title-p">是否展示</div>
              <div class="title-con">
                {{ row.showCustomerInfo == 1 ? "展示" : "隐藏" }}
              </div>
            </div>
            <div class="Instruction">
              (用于发票展示信息，包括开户银行、开户账号、住所)
            </div>
          </div>
        </div>

        <div class="section-invoice">
          <div class="title">开票信息</div>
         
          <div class="invoice-grid">
            <div class="Content-box">
              <div class="title-p">开票数量</div>
              <div class="title-con">{{ row.invoiceQuantity }}张</div>
            </div>
            <div class="Content-box">
              <div class="title-p">发票类型</div>
              <div class="title-con">{{ row.invoiceAttrName }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">开票格式</div>
              <div class="title-con">{{ row.invoiceFormatName }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">发送方式</div>
              <div class="title-con">
                {{ row.sendType == 2 ? "邮箱" : "企业微信"
                }}<span v-if="row.sendType == 2">（{{ row.mail }}）</span>
              </div>
            </div>
            <div class="Content-box">
              <div class="title-p">服务豆数</div>
              <div class="title-con">{{ row.amount || "--" }}发票豆</div>
            </div>
            <div class="Content-box">
              <div class="title-p">订单时间</div>
              <div class="title-con">{{ row.orderTime || "--" }}</div>
            </div>
          </div>
          <div class="Content-box full-row">
            <div class="title-p">开票信息</div>
            <div class="title-con">{{ row.businessInfo }}</div>
          </div>
          <div class="Content-box full-row" v-if="row.reissueReason">
            <div class="title-p">重开说明</div>
            <div class="title-con">{{ row.reissueReason }}</div>
          </div>
          <div class="Content-box full-row">
            <div class="title-p">备注</div>
            <div class="title-con">{{ row.remark || "--" }}</div>
          </div>
        </div>
        <div class="section-invoice refund-block" v-if="DeRe == 1 || DeRe == 2">
          <div class="title">退款信息</div>
          <div class="invoice-grid">
            <div class="Content-box" v-if="DeRe == 1">
              <div class="title-p">退豆数量</div>
              <div class="title-con">{{ row.amount }}发票豆</div>
            </div>
            <div class="Content-box" v-if="DeRe == 2">
              <div class="title-p">退豆原因</div>
              <div class="title-con">{{ dataObj.refundReason || "--" }}</div>
            </div>
            <div class="Content-box" v-if="DeRe == 2">
              <div class="title-p">实际退豆数量</div>
              <div class="title-con">
                {{
                  dataObj.refundAmount != null ? dataObj.refundAmount : "--"
                }}发票豆
              </div>
            </div>
          </div>
          <div class="Instruction">
            (含列入风险纳税人所需交的发票豆，实际退豆需后台审核)
          </div>
          <div class="Content-box full-row refund-reason" v-if="DeRe == 1">
            <div class="title-p">退豆原因</div>
            <div class="title-con refund-input">
              <el-input
                type="textarea"
                class="textarea-lg"
                placeholder="请输入退豆原因"
                v-model="textarea"
                :rows="5"
                maxlength="1500"
                show-word-limit
                resize="none"
              >
              </el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  </dialogModel>
</template>

<script>
export default {
  props: {
    VisibleDeRe: {},
    DeRe: {}, ///0详情1申请代开发票退款 2退款详情
    row: {}, //数据
    seller: {}, //销售方信息

    dataObj: {}, //申请退款中需要展示的数据
  },
  components: {},
  data() {
    return {
      textarea: "", //备注
    };
  },
  computed: {
    dialogTitle() {
      return this.DeRe == 0 ? "详情信息" : "申请退款";
    },
  },
  created() {},
  methods: {
    // 取消
    handleClose() {
      this.$emit("handleCloseDeRe");
      this.textarea = "";
    },
    // 确认
    handleUnderstand() {
      this.$emit("handleConfirmDeRe", this.textarea);
      this.textarea = "";
    },
  },
};
</script>

<style scoped lang="less">
.detail-status {
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
}

/deep/.el-textarea {
  width: 100%;
  min-height: 100px !important;
}

/deep/ .el-textarea .el-input__count {
  bottom: 5px !important;
  right: 10px !important;
  background: #fff !important;
  line-height: 1;
  z-index: 1;
}

.Content {
  width: 100%;
  min-height: 100px;
  box-sizing: border-box;

  .section-row {
    display: flex;
    align-items: flex-start;
    width: 100%;
  }

  .section-col {
    flex: 1 1 0;
    min-width: 0;
    padding: 0 20px;
    box-sizing: border-box;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }

    &:not(:last-child) {
      border-right: 1px solid #edeff2;
    }
  }

  .section-invoice {
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #edeff2;

    .title {
      text-align: center;
      font-weight: 700;
    }

    .invoice-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      column-gap: 24px;
      row-gap: 4px;
      width: 100%;
    }

    .full-row {
      width: 100%;
    }

    .Content-box {
      .title-p {
        flex: 0 0 90px;
        width: 90px;
      }
    }
  }

  .title {
    font-weight: 700;
    font-size: 16px;
    color: #1a1a1a;
    line-height: 22px;
    margin-bottom: 14px;
    text-align: center;
  }

  .Instruction {
    line-height: 18px;
    margin-top: 4px;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
  }

  .Content-box {
    min-height: 20px;
    margin-bottom: 12px;
    display: flex;
    align-items: flex-start;
    min-width: 0;

    .title-con {
      flex: 1;
      min-width: 0;
      text-align: left;
      font-weight: 400;
      font-size: 14px;
      color: #1a1a1a;
      margin-left: 0;
      word-break: break-all;
    }

    .title-p {
      flex: 0 0 140px;
      width: 140px;
      font-weight: 400;
      font-size: 14px;
      color: #828794;
      text-align: left;
      white-space: nowrap;

      &::after {
        content: "：";
      }
    }
  }

  .refund-block {
    .Instruction {
      margin-bottom: 12px;
    }

    .refund-reason {
      align-items: flex-start;

      .refund-input {
        flex: 1;
        min-width: 0;
      }
    }

    /deep/ .textarea-lg {
      width: 100% !important;
      max-width: 900px !important;
    }

    /deep/ .textarea-lg .el-textarea__inner {
      min-height: 120px !important;
      height: 120px !important;
      line-height: 22px !important;
      padding: 10px 12px 28px !important;
    }

    /deep/ .textarea-lg .el-input__count {
      bottom: 8px !important;
      right: 12px !important;
      background: #fff !important;
    }
  }
}
</style>
